import { render, staticRenderFns } from "./RoleReset.vue?vue&type=template&id=67e9c388&scoped=true&lang=pug&"
import script from "./RoleReset.vue?vue&type=script&lang=js&"
export * from "./RoleReset.vue?vue&type=script&lang=js&"
import style0 from "./RoleReset.vue?vue&type=style&index=0&id=67e9c388&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67e9c388",
  null
  
)

export default component.exports